import React, { useState } from 'react'
import axios from 'axios'
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
	Snackbar
} from '@material-ui/core'
import { Close, Delete, DeleteOutline, Edit } from '@material-ui/icons'
import Ubdatedail from './EditModel'

import iziToast from 'izitoast'
import EditQuestionBank from './EditQuestionBank'

import { makeStyles, useTheme } from '@material-ui/core/styles'
import { useStoreon } from 'storeon/react'
const useStyles = makeStyles(() => ({
	noScroll: {
		overflowY: 'scroll',
		scrollbarWidth: 'none',
		'-ms-overflow-style': 'none',
		'&::-webkit-scrollbar': {
			display: 'none'
		}
	}
}))
const Actionbuttons = ({ parentId, refreshData }) => {
	const [openDialog, setOpenDialog] = useState(false)
	const [openSnackbar, setOpenSnackbar] = useState(false)
	const { token } = useStoreon('token')
	const classes = useStyles()
	const [openEditDialog, setOpenEditDialog] = useState(false)

	const handleClickOpen = () => {
		setOpenDialog(true)
	}

	const handleCloseDialog = () => {
		setOpenDialog(false)
	}

	const handleOpenEditDialog = () => {
		setOpenEditDialog(true)
	}

	const handleCloseEditDialog = () => {
		setOpenEditDialog(false)
	}

	const handleDelete = async () => {
		try {
			const response = await axios.delete(
				`${process.env.REACT_APP_API_URL}/api/v1/custom/deleteQuestion`,
				{
					data: {
						questionId: parentId
					},
					headers: {
						Authorization: ` ${token}` // Watch for extra space after `Bearer` if you're using it
					}
				}
			)

			// console.log('Deleted successfully:', response.data)

			iziToast.success({
				message: 'Question deleted successfully!'
			})

			setOpenDialog(false)
			setOpenSnackbar(true)
			refreshData()
		} catch (error: any) {
			console.error('Error while deleting:', error)

			const errorMessage =
				error?.response?.data?.message || 'Something went wrong while deleting.'

			iziToast.error({
				message: errorMessage
			})
		}
	}

	return (
		<div style={{ display: 'flex' }}>
			<IconButton
				aria-label="edit"
				onClick={handleOpenEditDialog}
				sx={{ borderRadius: 0, width: 40, height: 40 }}
			>
				<Edit style={{ color: '#7D6EF1' }} />
			</IconButton>

			<IconButton
				aria-label="delete"
				onClick={handleClickOpen}
				sx={{ borderRadius: 0, width: 30, height: 40 }}
			>
				<DeleteOutline style={{ color: 'red' }} />
			</IconButton>

			<Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="xs" fullWidth>
				<DialogTitle>Confirm Delete</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Are you sure you want to delete this item? This action cannot be undone.
					</DialogContentText>
				</DialogContent>

				<DialogActions>
					<Button onClick={handleCloseDialog} variant="outlined">
						Cancel
					</Button>
					<Button
						onClick={handleDelete}
						variant="contained"
						sx={{
							backgroundColor: '#B22222',
							'&:hover': {
								backgroundColor: '#cc3d3d'
							}
						}}
					>
						Ok
					</Button>
				</DialogActions>
			</Dialog>

			<Dialog open={openEditDialog} maxWidth="lg" fullWidth>
				<DialogTitle
					disableTypography
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						backgroundColor: 'rgb(125, 110, 241)',
						height: '50px',
						color: 'white',
						padding: '0 16px'
					}}
				>
					<h2 style={{ margin: 0, fontSize: '1.25rem' }}>Edit Question</h2>
					{/* <IconButton onClick={handleCloseEditDialog} style={{ marginRight: '-18px' }}> */}
					<Close
						style={{ color: 'white', cursor: 'pointer' }}
						onClick={handleCloseEditDialog}
					/>
					{/* </IconButton> */}
				</DialogTitle>

				<DialogContent className={classes.noScroll}>
					<EditQuestionBank
						parentId={parentId}
						handleCloseEditDialog={handleCloseEditDialog}
						refreshData={refreshData}
					/>
				</DialogContent>
			</Dialog>
		</div>
	)
}

export default Actionbuttons
